import React from 'react'
import Wrapper from '../common/Wrapper'
import Submenu from '../common/Submenu'
import PaymentAccount from './PaymentAccount'
import Donate from './Donate'


const Payment = () => {
    return (
        <Wrapper renderButtonNav = {false}>
            <div className="container content">
                <Submenu />
                <Donate />
                {/*<PaymentAccount />*/}
            </div>
        </Wrapper>
    )
}

export default Payment









// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Payment/index.js